declare namespace $ {

	type $easyreels_labeler_name__title_easyreels_user_recording_1 = $mol_type_enforce<
		string
		,
		ReturnType< $easyreels_labeler_name['title'] >
	>
	type $easyreels_labeler_name__value_easyreels_user_recording_2 = $mol_type_enforce<
		ReturnType< $easyreels_user_recording['status_text'] >
		,
		ReturnType< $easyreels_labeler_name['value'] >
	>
	type $easyreels_labeler_name__title_easyreels_user_recording_3 = $mol_type_enforce<
		string
		,
		ReturnType< $easyreels_labeler_name['title'] >
	>
	type $easyreels_labeler_name__value_easyreels_user_recording_4 = $mol_type_enforce<
		ReturnType< $easyreels_user_recording['size_text'] >
		,
		ReturnType< $easyreels_labeler_name['value'] >
	>
	type $easyreels_labeler_moment__title_easyreels_user_recording_5 = $mol_type_enforce<
		string
		,
		ReturnType< $easyreels_labeler_moment['title'] >
	>
	type $easyreels_labeler_moment__value_easyreels_user_recording_6 = $mol_type_enforce<
		ReturnType< $easyreels_user_recording['created_text'] >
		,
		ReturnType< $easyreels_labeler_moment['value'] >
	>
	type $mol_row__sub_easyreels_user_recording_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_paragraph__title_easyreels_user_recording_8 = $mol_type_enforce<
		ReturnType< $easyreels_user_recording['failure_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_easyreels_user_recording_9 = $mol_type_enforce<
		ReturnType< $easyreels_user_recording['failure_detail'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_list__rows_easyreels_user_recording_10 = $mol_type_enforce<
		ReturnType< $easyreels_user_recording['segment_links'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_link__uri_easyreels_user_recording_11 = $mol_type_enforce<
		ReturnType< $easyreels_user_recording['segment_uri'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__file_name_easyreels_user_recording_12 = $mol_type_enforce<
		ReturnType< $easyreels_user_recording['segment_file'] >
		,
		ReturnType< $mol_link['file_name'] >
	>
	type $mol_link__title_easyreels_user_recording_13 = $mol_type_enforce<
		ReturnType< $easyreels_user_recording['segment_title'] >
		,
		ReturnType< $mol_link['title'] >
	>
	export class $easyreels_user_recording extends $mol_view {
		status_text( ): string
		Status( ): $easyreels_labeler_name
		size_text( ): string
		Size( ): $easyreels_labeler_name
		created_text( ): string
		Created( ): $easyreels_labeler_moment
		Row( ): $mol_row
		failure_text( ): string
		Failure( ): $mol_paragraph
		failure_detail( ): string
		Failure_detail( ): $mol_paragraph
		segment_links( ): readonly($mol_view)[]
		Segments( ): $mol_list
		content( ): readonly($mol_view)[]
		segment_uri( id: any): string
		segment_file( id: any): string
		segment_title( id: any): string
		recording( ): any
		sub( ): ReturnType< $easyreels_user_recording['content'] >
		Segment_link( id: any): $mol_link
	}
	
}

//# sourceMappingURL=recording.view.tree.d.ts.map